import { StateCreator } from "zustand";
import { WidgetStore, UIState, UIActions } from "../types";

const initialUIState: UIState = {
  buttonState: "idle",
  isRecording: false,
  isAgentSpeaking: false,
  isWidgetActive: false,
  isWidgetDisabled: false,
  isAgentThinking: false,
};

export const createUISlice: StateCreator<
  WidgetStore,
  [],
  [],
  UIState & UIActions
> = (set) => ({
  ...initialUIState,

  setButtonState: (buttonState) => set({ buttonState }),

  setIsRecording: (isRecording) => set({ isRecording }),

  setIsAgentSpeaking: (isAgentSpeaking) => set({ isAgentSpeaking }),

  setWidgetActive: (isWidgetActive) => set({ isWidgetActive }),

  setIsWidgetDisabled: (isWidgetDisabled) => set({ isWidgetDisabled }),

  setIsAgentThinking: (isAgentThinking) => set({ isAgentThinking }),

  resetUI: () => set(initialUIState),
});
